import { render, staticRenderFns } from "./l6-back-svg.vue?vue&type=template&id=5f5570ca&"
import script from "./l6-back-svg.vue?vue&type=script&lang=js&"
export * from "./l6-back-svg.vue?vue&type=script&lang=js&"
import style0 from "./l6-back-svg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports